import { namespace } from "@js/guide/util";
import GuideHome from "@js/guide/guideHome";
import Guide from "@js/guide/guide";

(function ($) {
  "use strict";

  namespace("nc.aion");

  // 신규/복귀가이드 - 가이드홈
  nc.aion.guideHome = () => new GuideHome();

  // 신규/복귀가이드 - 가이드
  nc.aion.guide = (
    options = { apiDomain: null, isLive: null, isElyos: null }
  ) => new Guide(options);
})(jQuery);
